import { ca } from '@cian/analytics';

import { createDeveloperProduct } from 'shared/utils/analytics';

/**
 * @description Событие: нажата кнопка «Показать ещё» / раскрытие дополнительных ЖК в блоке проектов.
 */
export function trackPikProjectsShowMoreJk(): void {
  ca('eventSite', {
    action: 'click_pik_projects_show_more_jk',
    category: 'Promo',
    label: 'show_more',
    name: 'oldevent',
    products: [createDeveloperProduct()],
  });
}
